<template>
  <svg
    version="1.0"
    viewBox="0 0 541.04 390"
    xml:space="preserve"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="st1"
      fill="#00A3FF"
      d="m468.46 318.5c-8.7 8.7-26.1 21.7-56.5 21.7h-187c56.5-54.1 104.4-99.6 108.8-104 8.3-8.4 17-16.3 26.1-23.8 21.8-19.5 39.1-21.7 54.4-21.7 21.7 0 39.1 8.7 54.4 21.6 30.3 28.2 30.3 78.1-0.2 106.2zm37-140.9c-23-24.8-55.3-39-89.2-39-30.4 0-56.5 10.9-80.5 28.2-8.8 8.7-21.8 17.3-32.7 30.3-8.7 8.7-195.7 190.7-195.7 190.7 10.9 2.2 23.9 2.2 34.8 2.2h237.1c17.4 0 30.5 0 43.5-2.2 30-2.2 58.3-14.4 80.5-34.7 50-47.6 50-127.7 2.2-175.5z"
    />
    <path
      class="st2"
      fill="#00C8DC"
      d="m200.96 164.6c-23.9-17.3-47.9-26-76.1-26-33.9 0-66.2 14.2-89.2 39-48.4 49.7-47.4 129.2 2.2 177.7 21.7 19.5 43.5 30.3 69.6 32.5l50-47.7h-28.3c-28.3-2.1-45.7-10.8-56.5-21.6-30-29.6-30.9-77.6-2.2-108.3 15.2-15.2 32.6-21.7 54.4-21.7 13.1 0 32.6 2.1 52.2 21.6 8.7 8.7 32.6 26 41.3 34.7h2.1l32.6-32.5v-2.2c-15.1-15.1-39-34.6-52.1-45.5"
    />
    <path
      class="st3"
      fill="#006EFF"
      d="m429.36 110.5c-24.7-66.3-88-110.4-158.8-110.5-84.8 0-152.2 62.8-165.3 140.8 6.5 0 13.1-2.1 21.8-2.1s19.6 2.1 28.3 2.1c10.9-54.2 58.7-93.2 115.3-93.2 47.8 0 89.2 28.2 108.7 69.3 0 0 2.2 2.2 2.2 0 15.1-2.1 32.5-6.4 47.8-6.4"
    />
  </svg>
</template>
